import { Component } from '@angular/core';

@Component({
  selector: 'app-permission-role-user-search',
  templateUrl: './user-search.component.html',
  styleUrls: ['./user-search.component.css']
})
export class UserSearchComponent {

}
